import { message } from "antd";
import { api } from "../apiCore";
import { DocumentWithFileArchive } from "../../../types/documents.type";
import { applicationBankApi } from "./applicationBank.api";

export type ChangeOfferDto = {
  bank_rate: string;
  base_commission: string;
  overstatement: string;
  final_commission: string;
  agent_commission: string;
};

export const offerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Изменить (сохранить) данные предложения
    changeOffer: builder.mutation<
      ChangeOfferDto,
      {
        applicationBankId: number;
        changeOfferDto: ChangeOfferDto;
      }
    >({
      query: ({ applicationBankId, changeOfferDto }) => {
        return {
          url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/offer`,
          method: "POST",
          body: changeOfferDto,
        };
      },
      transformResponse: (response: { data: ChangeOfferDto }) => response.data,
      async onQueryStarted(
        { applicationBankId },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedOffer } = await queryFulfilled;

          dispatch(
            applicationBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              applicationBankId,
              (draft) => {
                Object.assign(draft, updatedOffer);
              }
            )
          );
          message.success("Предложение сохранено успешно");
        } catch {
          message.error("Не удалось сохранить предложение");
        }
      },
    }),

    // сгенерировать документы предложения
    generateOfferDocuments: builder.mutation<DocumentWithFileArchive[], number>(
      {
        query: (applicationBankId) => {
          return {
            url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/create-group-offer`,
            method: "POST",
          };
        },
        transformResponse: (response: { message: DocumentWithFileArchive[] }) =>
          response.message,
        async onQueryStarted(applicationBankId, { queryFulfilled, dispatch }) {
          try {
            const { data: updatedOfferDocuments } = await queryFulfilled;

            dispatch(
              applicationBankApi.util.updateQueryData(
                "getApplicationDataToBank",
                applicationBankId,
                (draft) => {
                  draft.offer = updatedOfferDocuments;
                }
              )
            );
            message.success("Документы успешно сформированы");
          } catch {
            message.error("Не удалось сформировать документы");
          }
        },
      }
    ),

    // отправить документ предложения
    uploadOfferDocument: builder.mutation<
      any,
      {
        file: File;
        applicationBankId: number;
        typeDocId: number;
      }
    >({
      query: ({
        file,
        applicationBankId,
        typeDocId,
      }: {
        file: File;
        applicationBankId: number;
        typeDocId: number;
      }) => {
        const bodyFormData = new FormData();
        bodyFormData.append("type_doc_id", `${typeDocId}`);
        bodyFormData.append("file", file);

        return {
          url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file`,
          method: "POST",
          body: bodyFormData,
          formData: true,
        };
      },
      transformResponse: (res) => res.data,
      invalidatesTags: ["ApplicationBank"],
      async onQueryStarted(applicationBankId, { queryFulfilled }) {
        try {
          await queryFulfilled;

          message.success("Документ успешно отправлен");
        } catch {
          message.error("Не удалось отправить документ");
        }
      },
    }),
  }),
});

export const {
  useChangeOfferMutation,
  useGenerateOfferDocumentsMutation,
  useUploadOfferDocumentMutation,
} = offerApi;
